import { isNil } from "lodash";
import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const TimelineItemChildrenBorder = props => {
  let nodeStyle = {
    left: `${props.rect.left}px`,
    top: `${props.rect.top}px`,
    width: `${props.rect.width}px`,
    height: `${props.rect.height}px`,
    opacity: isNil(props.opacity) ? 1 : props.opacity
  };

  const gapAfter = Math.max(props.rect.width - 5 - props.gapLeft - props.gapWidth, 0);
  const d = `M5,0 h${props.gapLeft - 5} m${props.gapWidth},0 h${gapAfter} a5,5 0 0 1 5,5 v${props.rect.height -
    10} a5,5 0 0 1 -5,5 h-${props.rect.width - 10} a5,5 0 0 1 -5,-5 v-${props.rect.height - 10} a5,5 0 0 1 5,-5`;

  return (
    <div className={`timelineEventChildrenBorder ${props.color}`} style={nodeStyle}>
      <svg width={Math.ceil(props.rect.width)} height={Math.ceil(props.rect.height)}>
        <path d={d} strokeWidth="1" />
      </svg>
    </div>
  );
};

TimelineItemChildrenBorder.propTypes = {
  color: PropTypes.string.isRequired,
  rect: PropTypeShapes.flatRect.isRequired,
  opacity: PropTypes.number,
  gapLeft: PropTypes.number.isRequired,
  gapWidth: PropTypes.number.isRequired
};

export default TimelineItemChildrenBorder;
